import { Controller } from "@hotwired/stimulus"

// Reloads the turbo-frame it sits in every so often while something renders
// on the server (the persona's living clips, persona/_life). It lives INSIDE
// the frame, and the server stops rendering it once there is nothing left to
// wait for, so the reloads end on their own.
export default class extends Controller {
  static values = { every: { type: Number, default: 15000 }, url: String, holdWhile: String }

  connect() {
    this._timer = setInterval(() => {
      if (document.visibilityState !== "visible") return
      // Reloading replaces the frame's content, which would close whatever the person opened in it.
      if (this.holdWhileValue && document.querySelector(this.holdWhileValue)) return
      const frame = this.element.closest("turbo-frame")
      if (!frame) return
      if (this.urlValue) frame.src = `${this.urlValue}${this.urlValue.includes("?") ? "&" : "?"}t=${Date.now()}`
      else frame.reload?.()
    }, this.everyValue)
  }

  disconnect() {
    clearInterval(this._timer)
  }
}
